import { AppLayout } from "@bcc/components/app-layout";
import { FinanceDashboardView } from "@bcc/components/views/finance-dashboard-view";

interface PaymentTrendDataPoint {
  month: string;
  invoices: number;
  payments: number;
}

export function FinanceDashboardPage() {
  const paymentTrendData: PaymentTrendDataPoint[] = [
    { month: "July", invoices: 45, payments: 38 },
    { month: "August", invoices: 52, payments: 45 },
    { month: "September", invoices: 48, payments: 42 },
    { month: "October", invoices: 61, payments: 55 },
    { month: "November", invoices: 58, payments: 51 },
    { month: "December", invoices: 68, payments: 62 },
  ];

  return (
    <AppLayout>
      <FinanceDashboardView paymentTrendData={paymentTrendData} />
    </AppLayout>
  );
}
